// Libellés des générations affichés dans l'UI.

import type { GenerationId } from "../types/battle.js";

export const GENERATIONS: Record<GenerationId, string> = {
  1: "Gen 1 — Kanto",
  2: "Gen 2 — Johto",
  3: "Gen 3 — Hoenn",
  4: "Gen 4 — Sinnoh",
  5: "Gen 5 — Unova",
  6: "Gen 6 — Kalos",
  7: "Gen 7 — Alola",
  8: "Gen 8 — Galar",
  9: "Gen 9 — Paldea",
};
